/**
 * @Date: 2024-01-09 13:33:36
 * @FilePath: /actdianyuan/src/router/router2024.js
 * @Author: zwy
 * @Description:
 */

const Act2024 = [
  // 电源完整性测试基本法
  {
    path: "/keysight240109/index",
    name: "keysight240109",
    component: (resolve) =>
      require(["@/act2024/keysight240109/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight240109/download",
    name: "keysight240109Download",
    component: (resolve) =>
      require(["@/act2024/keysight240109/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  //新能源与储能技术
  {
    path: "/chuneng2024/index",
    name: "chuneng2024waizhan",
    component: (resolve) => require(["@/act2024/chuneng2024/index"], resolve),
    meta: {
      title: "新能源与储能技术",
    },
  },
  // 2024示波器专场精彩SI
  {
    path: "/keysightjingce240227/index",
    name: "keysightjingce240227",
    component: (resolve) =>
      require(["@/act2024/keysightjingce240227/index.vue"], resolve),
    meta: {
      title: "2024示波器专场精彩SI",
    },
  },
  // 2024示波器专场精彩SI视频
  {
    path: "/keysightjingce240227/videos",
    name: "keysightjingce240227videos",
    component: (resolve) =>
      require(["@/act2024/keysightjingce240227/videos.vue"], resolve),
    meta: {
      title: "2024示波器专场精彩SI",
    },
  },
  // 2024示波器专场车载总线和电子的测试
  {
    path: "/keysightancheng240227/index",
    name: "keysightancheng240227",
    component: (resolve) =>
      require(["@/act2024/keysightancheng240227/index.vue"], resolve),
    meta: {
      title: "2024示波器专场车载总线和电子的测试",
    },
  },
  // 2024示波器专场车载总线和电子的测试
  {
    path: "/keysightancheng240227/videos",
    name: "keysightancheng240227videos",
    component: (resolve) =>
      require(["@/act2024/keysightancheng240227/videos.vue"], resolve),
    meta: {
      title: "2024示波器专场车载总线和电子的测试",
    },
  },
  // 新能源汽车三电的测试
  {
    path: "/keysightkangqi240227/index",
    name: "keysightkangqi240227",
    component: (resolve) =>
      require(["@/act2024/keysightkangqi240227/index.vue"], resolve),
    meta: {
      title: "新能源汽车三电的测试",
    },
  },
  // 新能源汽车三电的测试
  {
    path: "/keysightkangqi240227/videos",
    name: "keysightkangqi240227videos",
    component: (resolve) =>
      require(["@/act2024/keysightkangqi240227/videos.vue"], resolve),
    meta: {
      title: "新能源汽车三电的测试",
    },
  },
  // 2024中国国际清洁能源博览会
  {
    path: "/ceec240318/index",
    name: "ceec240318",
    component: (resolve) =>
      require(["@/act2024/ceec240318/index.vue"], resolve),
    meta: {
      title: "2024中国国际清洁能源博览会",
    },
  },
  // 电源完整性测试基本法2
  {
    path: "/keysight240320/index",
    name: "keysight240320",
    component: (resolve) =>
      require(["@/act2024/keysight240320/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  {
    path: "/keysight240320/download",
    name: "keysight240320Download",
    component: (resolve) =>
      require(["@/act2024/keysight240320/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  // // 是德示波器功率与器件测试宝典
  // {
  //     path: "/keysight240424/index",
  //     name: "keysight240424",
  //     component: (resolve) =>
  //         require(["@/act2024/keysight240424/index.vue"], resolve),
  //     meta: {
  //         title: "参与是德问卷，获取演讲资料",
  //     },
  // },
  {
    path: "/livedata/download",
    name: "livedata240424Download",
    component: (resolve) =>
      require(["@/act2024/keysight240424/download"], resolve),
    meta: {
      title: "keysight直播演讲资料下载",
    },
  },
  // MPS活动
  {
    path: "/mps240424/index",
    name: "mps240424",
    component: (resolve) => require(["@/act2024/mps240424/index.vue"], resolve),
    meta: {
      title: "采用后置滤波器反馈的数字D类音频放大器",
    },
  },
  // 小视频---q3---贝奇
  {
    path: "/keysight240515bq/index",
    name: "keysight240515bq",
    component: (resolve) =>
      require(["@/act2024/keysight240515bq/index.vue"], resolve),
    meta: {
      title: "高速数字电路电源和信号完整性测试",
    },
  },
  // 小视频---q3---精测
  {
    path: "/keysight240515jc/index",
    name: "keysight240515jc",
    component: (resolve) =>
      require(["@/act2024/keysight240515jc/index.vue"], resolve),
    meta: {
      title: "新能源汽车三电的测试",
    },
  },
  // 示波器---q3---康祺
  {
    path: "/keysight240515kq/index",
    name: "keysight240515kq",
    component: (resolve) =>
      require(["@/act2024/keysight240515kq/index.vue"], resolve),
    meta: {
      title: "电源质量",
    },
  },
  {
    path: "/livedata/index/:liveId/:queId",
    name: "keysight240520",
    component: (resolve) =>
      require(["@/act2024/keysight240424/index.vue"], resolve),
    meta: {
      title: "参与是德问卷，获取演讲资料",
    },
  },
  // 2024年慕尼黑
  {
    path: "/munihei20240607/index",
    name: "munihei20240607",
    component: (resolve) =>
      require(["@/act2024/munihei20240607/index.vue"], resolve),
    meta: {
      title: "慕尼黑上海电子展",
    },
  },
  // 示波器---q4---精测
  {
    path: "/keysight240826jc/index",
    name: "keysight240826jc",
    component: (resolve) =>
      require(["@/act2024/keysight240826jc/index.vue"], resolve),
    meta: {
      title: "信号完整性",
    },
  },
  // 示波器---q4---安诚
  {
    path: "/keysight240826ac/index",
    name: "keysight240826ac",
    component: (resolve) =>
      require(["@/act2024/keysight240826ac/index.vue"], resolve),
    meta: {
      title: "第三代半导体及电源测试实操课",
    },
  },
  // 示波器---q4---康祺
  {
    path: "/keysight240826kq/index",
    name: "keysight240826kq",
    component: (resolve) =>
      require(["@/act2024/keysight240826kq/index.vue"], resolve),
    meta: {
      title: "车载总线测试和协议解码",
    },
  },
  // 示波器---q411---精测
  {
    path: "/keysight2411jc/index",
    name: "keysight2411jc",
    component: (resolve) =>
      require(["@/act2024/keysight2411jc/index.vue"], resolve),
    meta: {
      title: "HD3新品测试",
    },
  },
];

export default Act2024;
